import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
	Row,
	Col,
	Label,
	Container,
	CardBody,
	Card,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { getMediaBuyerDataForAdd } from "./../../../../store/mediabuyers/mediabuyerbudget/actions";
import { getMediaBuyerPlansById } from "./../../../../store/mediabuyers/mediabuyerplans/actions";
import { patchPlan } from "./../../../../store/mediabuyers/mediabuyerplans/actions";
import Select from "react-select";
import {withRouter} from 'react-router-dom';
import { setMediaBuyerPlansForId } from "../../../../store/mediabuyers/mediabuyerplans/actions";

const EditMediaBuyerPlanOffer = props => {
	const [mediaBuyerSelect, setMediaBuyerSelect] = React.useState(null);

	let state = {
		isFormSubmit: false,
	};

	React.useEffect(() => {
		const client_id = props.match.params.id;
		props.getMediaBuyerPlansById(client_id);
		props.getMediaBuyerDataForAdd();

		return () => {
			setMediaBuyerSelect(null);
			props.setMediaBuyerPlansForId(null);
		}
	}, []);

	React.useEffect(() => {
		if (mediaBuyerSelect === null && props.client_plan !== null) {
				let inx = props.dataForAddBudget.mediaBuyers.findIndex(
					x => x.id === props.client_plan.media_buyer
				);
				setMediaBuyerSelect({
					label: props.dataForAddBudget.mediaBuyers[inx].number,
					value: props.dataForAddBudget.mediaBuyers[inx].id,
				});
		}
	}, [props.dataForAddBudget, props.client_plan]);

	const getMediaBuyers = item => {
		let media = [];
		item.mediaBuyers.map(i => {
			media.push({ label: i.number, value: i.id });
		});
		return media;
	};

	const onSubmitForm = (e, errors, params) => {
		state = { isFormSubmit: true };
		if (errors?.length === 0) {
			const offer_id = props.match.params.offerId;
			let data = {
				offer: offer_id,
				media_buyer: mediaBuyerSelect.value,
				planned_sum: params.planned_sum,
			};
			const client_id = props.match.params.id;
			props.patchMediaBuyerPlan(client_id, data);
			return props.history.push(`/offers/${offer_id}#media-buyer-plans`);
		}
	};

	return (
		<div className="page-content">
			{props.client_plan && (
				<Container fluid>
					<Breadcrumbs title="Media buyer plans" breadcrumbItem={props.client_plan.media_buyer} link="/plans" />
					<Row>
						<Col className="col-12">
							<Card>
								<CardBody>
									<AvForm className="needs-validation" onSubmit={onSubmitForm}>
										<Row>
											<Col md={6}>
												<div className="mb-3">
													<Label htmlFor="offer">Media buyer</Label>
													<Select
														name="mediaBuyer"
														options={
															props.dataForAddBudget !== null &&
															getMediaBuyers(props.dataForAddBudget)
														}
														value={mediaBuyerSelect}
														onChange={setMediaBuyerSelect}
														required
														isLoading={mediaBuyerSelect === null}
														isFormSubmit={state.isFormSubmit}
													/>
												</div>
											</Col>
											<Col md={6}>
												<div className="mb-3">
													<AvField
														name="planned_sum"
														label="Planned sum"
														type="number"
														value={
															props.client_plan &&
															props.client_plan.planned_sum.toString()
														}
														errorMessage="Invalid   budget"
														validate={{
															required: { value: true },
															minLength: {
																value: 1,
																errorMessage: "Min 1 number",
															},
														}}
													/>
												</div>
											</Col>
										</Row>
										<Row>
											<Col>
												<div className="text-end">
													<button
														type="submit"
														className="btn btn-success save-user"
													>
														Save changes
													</button>
												</div>
											</Col>
										</Row>
									</AvForm>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			)}
		</div>
	);
};

EditMediaBuyerPlanOffer.propTypes = {
	history: PropTypes.object.isRequired,
	data: PropTypes.object.isRequired,
	getMediaBuyerPlansById: PropTypes.func.isRequired,
	match: PropTypes.object.isRequired,
	client_plan: PropTypes.object,
	getMediaBuyerDataForAdd: PropTypes.func.isRequired,
	dataForAddBudget: PropTypes.object,
	patchMediaBuyerPlan: PropTypes.func.isRequired,
	setMediaBuyerPlansForId: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	data: state.MediaBuyerPlans.data,
	client_plan: state.MediaBuyerPlans.client_plan,
	dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget,
});

export default connect(mapStateToProps, {
	getMediaBuyerPlansById,
	getMediaBuyerDataForAdd,
	patchMediaBuyerPlan: patchPlan,
	setMediaBuyerPlansForId
})(withRouter(EditMediaBuyerPlanOffer));
